import type { CurriculumConceptTreeNode } from '@mathflat/domain/Curriculum'

import dataConvertService from '@/service/dataConvert.service'

import { DTO } from '../DTO'
import type { CurriculumTreeNode } from './CurriculumTreeNode'

export class CurriculumTreeByChapter extends DTO {
  curriculumTreeNode: CurriculumTreeNode[]
  curriculumTreeMap: Map<string, CurriculumConceptTreeNode>

  constructor(data: CurriculumConceptTreeNode[]) {
    super()

    const { treeNode, dataMap } = dataConvertService.curriculumToTreeData(data)

    this.curriculumTreeNode = treeNode
    this.curriculumTreeMap = dataMap
  }
}
